import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ChacraGeo} from "../../../../../chacra-core/models/chacra";

export const chacrasGeoAdapter: EntityAdapter<ChacraGeo> = createEntityAdapter<ChacraGeo>({
  selectId: model => model.idUnico,
  sortComparer: (a: ChacraGeo, b: ChacraGeo): number =>
    b.idUnico.toString().localeCompare(a.idUnico.toString())
});

export interface ChacrasGeoState extends EntityState<ChacraGeo> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: ChacrasGeoState = chacrasGeoAdapter.getInitialState(
  {
    isLoading: false,
    error: null,
  }
);
